import type { GroupKey, TodoId } from "@common/types/todo";
import type { Flavor } from "@common/utils/type-utils";

export type HighlightableId = Flavor<string, "HIGHLIGHT_ID">;
/**
 * The actual todoId, whereas the highlightable id includes the group.
 * A single todo id could present itself as distinct highlightables
 */
export function todoIdToHighlightId(todoId: TodoId, groupKey: GroupKey): HighlightableId {
  return `todo:${groupKey}:${todoId}`;
}

export function highlightIdToTodoId(compositeId: HighlightableId): TodoId | null {
  if (!compositeId || !compositeId.includes("todo:")) return null;
  const components = compositeId.split(":");
  if (components.length <= 2) return null;
  const [_, __, todoId] = components;
  return todoId!;
}
